import React from "react";
import "./Main.sass";

export default function Main() {
  return (
    <div className="bezos">
      <div className="bezos-bg-1">
        <div className="bezos-part1">
          <h2 className="bezos-title">
            On a a <strong> cold winter night</strong> , two shadowy figures
            meet behind a mountain- <strong>Bezos and Zuck!</strong> <br />{" "}
          </h2>
          <br />
          <h2 className="bezos-text-1">
            The <strong> Nefarious Bezos</strong> , with support from{" "}
            <strong> Zuck</strong> , has devised a plan for an organized{" "}
            <strong> attack on the entire cryptos</strong> market once again!
          </h2>
          <br />
          <h2 className="bezos-text-2">
            They are trying to steal our Cryptos and put us back to work
            entrapping us in a Wage Cage forever. This obvious ruse is a trick
            to steal the most valuable asset the world has ever before seen, our{" "}
            <strong> Super Secret Internet Computer Monies.</strong>
          </h2>
        </div>
      </div>
      <div className="bezos-bg-2">
        <div className="bezos-part2">
          <h2>
            For it is known whoever controls the Computer Monies, controls the
            future of the Metaverse itself. Zuck is currently assembling{" "}
            <strong>an army of robots</strong> to prepare an aggressive and{" "}
            <strong>hostile DDoS attack</strong> to takeover the metaverse using
            his new cleverly named company “Meta”.
          </h2>
        </div>
      </div>
      <div className="bezos-bg-3 mobile"></div>
    </div>
  );
}
